const { DebugContainer } = require('./container');

export default DebugContainer;